var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticStyle: { width: "100%", height: "50%" } },
        [
          _c("v-container", { staticClass: "container" }, [
            _c("p", { staticClass: "titulo" }, [
              _vm._v(_vm._s(_vm.elemento[0].titulo))
            ]),
            _c("p", { staticClass: "texto" }, [
              _vm._v(_vm._s(_vm.elemento[0].mensaje))
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }